
<template>
  <div>
    <el-card v-if="ei_auth" v-loading="loading" shadow="never">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="mb">
            <span class="front-line">增值收入</span>
          </div>
          <div class="bg-light radius5 pr pt pb pl flex column" style="height: 125px;">
            <div class="mb hd">
              <span>
                今日
                <b v-if="count_today_order == 0" class="font-md text-muted">{{ count_today_order }}</b>
                <b v-else class="font-md text-success">{{ count_today_order }}</b> 笔收入，共计
              </span>
            </div>
            <div class="bd flex align-items-center justify-content-space-between">
              <div class="flex text-success">
                <div role="button" @click="$router.push('/ei/order?type=1')">
                  <span class="font-2x ml-xs" :class="[income_today == 0 && 'text-muted']">{{ income_today | currency }}</span>
                </div>
              </div>
              <div class="flex align-items-center">
                <div class="pl-lg">
                  <div style="width: 80px;">较昨日</div>
                  <div class="mt-xs" style="width: 80px;">昨日收入</div>
                </div>
                <div class="flex1">
                  <div class="flex align-items-center">
                    <i v-if="compare_yesterday >= 0" class="el-icon-caret-top text-primary font-lg"></i>
                    <i v-else class="el-icon-caret-bottom text-danger font-lg"></i>
                    <span v-if="compare_yesterday > 0">{{ compare_yesterday| currency }}</span>
                    <span v-else-if="compare_yesterday == 0" class="text-muted">{{ compare_yesterday | currency }}</span>
                    <span v-else>{{ -compare_yesterday | currency }}</span>
                  </div>
                  <div class="mt-xs">
                    <span v-if="income_yesterday == 0" class="text-muted">{{ income_yesterday | currency }}</span>
                    <span v-else class="text-success">{{ income_yesterday | currency }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="bg-light radius5 pr pt pb pl flex column" style="height: 125px;margin-top: 34px">
            <div class="mb hd">
              <span>
                本月 
                <b v-if="cur_month_order == 0" class="font-md text-muted">{{ cur_month_order }}</b>
                <b v-else class="font-md text-success">{{ cur_month_order }}</b> 笔收入，共计
              </span>
            </div>
            <div class="bd flex align-items-center justify-content-space-between">
              <div class="flex text-success">
                <div role="button" @click="$router.push('/ei/order?type=2')">
                  <span class="font-2x ml-xs" :class="[income_cur_month == 0 && 'text-muted']">{{ income_cur_month | currency }}</span>
                </div>
              </div>
              <div class="flex align-items-center">
                <div class="pl-lg">
                  <div style="width: 80px;">较上月</div>
                  <div class="mt-xs" style="width: 80px;">上月收入</div>
                </div>
                <div class="flex1">
                  <div class="flex align-items-center">
                    <i v-if="compare_last_month >= 0" class="el-icon-caret-top text-primary font-lg"></i>
                    <i v-else class="el-icon-caret-bottom text-danger font-lg"></i>
                    <span v-if="compare_last_month > 0" >{{ compare_last_month | currency }}</span>
                    <span v-else-if="compare_last_month == 0" class="text-muted">{{ compare_last_month | currency }}</span>
                    <span v-else class="" >{{ -compare_last_month | currency }}</span>
                  </div>
                  <div class="mt-xs">
                    <span v-if="income_last_month == 0" class="text-muted">{{ income_last_month | currency }}</span>
                    <span v-else class="text-success">{{ income_last_month | currency }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="mb">
            <span class="front-line">远程服务统计</span>
          </div>
          <div class="bg-light radius5 item mb" role="button" @click="$router.push('/ei/rms?status=1')">
            <span class="title">
              <i class="el-icon-video-play text-primary" />服务正常
            </span>
            <span class="font-lg" :class="[count_rms_normal == 0 && 'text-muted']">{{ count_rms_normal }}</span>
          </div>
          <div class="bg-light radius5 item" role="button" @click="$router.push('/ei/rms?status=2')">
            <span class="title">
              <i class="el-icon-video-pause text-danger" />服务逾期
            </span>
            <span class="font-lg" :class="{ 'text-danger': count_rms_expired > 0,'text-muted': count_rms_expired == 0}">{{ count_rms_expired }}</span>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!-- <div v-else v-loading="loading" :class="ei_auth == null ? 'intro-default' : 'intro'" role="button" @click="$router.push('/ei')"></div> -->
  </div>
</template>

<script>
import { incomeOverviewApi } from "@/api/ei/eiApi";
export default {
  data() {
    return {
      loading: false,
      ei_auth: null,
      count_today_order: 0,
      income_today: 0,
      // yesterday_income_count: 0,
      income_yesterday: 0,
      count_rms_normal: 0,
      count_rms_expired: 0,
      cur_month_order: 0,
      income_cur_month: 0,
      income_last_month: 0,

      compare_yesterday: 0,
      compare_last_month: 0,
    };
  },

  created() {
    this.fetchStatus();
  },

  methods: {
    fetchStatus() {
      this.loading = true;
      incomeOverviewApi().then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.ei_auth = res.data.ei_status ? true : false;
          // this.yesterday_income_count = res.data.count_yesterday_order
          this.count_today_order = res.data.count_today_order;
          this.income_today = res.data.income_today;
          this.income_yesterday = res.data.income_yesterday;

          this.cur_month_order = res.data.cur_month_order;
          this.income_cur_month = res.data.income_cur_month;
          this.income_last_month = res.data.income_last_month;

          this.count_rms_normal = res.data.count_rms_normal;
          this.count_rms_expired = res.data.count_rms_expired;

          this.compare_yesterday = this.income_today - this.income_yesterday;
          this.compare_last_month = this.income_cur_month - this.income_last_month;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.intro {
  background: url("../../../assets/welcome-ei-intro.jpg") center center
    no-repeat;
  background-size: auto 100%;
  height: 200px;
  border-radius: 4px;
}
.intro-default {
  height: 200px;
}
.item {
  height: 55px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  .title {
    flex: none;
    width: 50%;
    display: flex;
    i {
      font-size: 20px;
      margin-right: 8px;
    }
  }
}
</style>
